<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-06 15:57:55
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-08 16:59:37
 * @name: 登录
 * @Description: 登录
 * @FilePath: \preSaleNafterSaleBackstage\src\views\Login.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="login">
    <div class="card">
      <div class="info">
        <font class="title">登录</font>
        <div class="line">
          <font class="label">账号</font>
          <el-input
            class="input"
            :value="loginClass.username"
            maxlength="11"
            @input="usernameInput"
            placeholder="请输入账号"
            clearable
          ></el-input>
        </div>
        <div class="line">
          <font class="label">密码</font>
          <el-input
            type="password"
            class="input"
            :value="loginClass.password"
            @input="passwordInput"
            placeholder="请输入密码"
            clearable
          ></el-input>
          <!-- <font class="forget" @click="forget">忘记密码?</font> -->
        </div>
        <div class="line">
          <font class="label">验证码</font>
          <el-input
            class="input"
            :value="loginClass.verificationCode"
            @input="verificationCodeInput"
            placeholder="请输入验证码"
            clearable
          ></el-input>
          <img
            class="img"
            :key="loginClass.verify"
            :src="loginClass.verify"
            @click="getVerify"
          />
        </div>
      </div>
      <div class="btnGroup">
        <el-button type="primary" @click="submit">登录</el-button>
        <!-- <el-button plain @click="register">注册</el-button> -->
      </div>
    </div>
    <a class="beian" href="https://beian.miit.gov.cn/" target="_blank">
      浙ICP备2022003281号-1
    </a>
  </div>
</template>
<script>
import loginClass from "@/object/login/login.class.js";
import { debounceation } from "@/utils/decorator";
export default {
  name: "login",
  data() {
    return {
      loginClass: new loginClass(), //登录对象实例
    };
  },
  created() {
    this.getVerify();
    // 设置监听回车键,调用登录
    document.addEventListener("keyup", (e) => {
      if (e.key === "Enter") {
        this.submit();
      }
    });
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取验证码
     */
    @debounceation(300)
    getVerify() {
      this.loginClass.getVerify();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 输入手机号码
     * @param {String} e 手机号码
     */
    usernameInput(e) {
      this.loginClass.username = e;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 输入密码
     * @param {String} e 密码
     */
    passwordInput(e) {
      this.loginClass.password = e;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 输入验证码
     * @param {String} e 验证码
     */
    verificationCodeInput(e) {
      this.loginClass.verificationCode = e;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击登录
     */
    @debounceation(300)
    submit() {
      this.loginClass
        .submit()
        .then((res) => {
          location.reload();
        })
        .catch((err) => {
          this.getVerify();
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击忘记密码
     */
    @debounceation(300)
    forget() {
      this.$router.push("/forgetPassword");
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击注册
     */
    @debounceation(300)
    register() {
      this.$router.push("/register");
    },
  },
};
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100vh;
  @extend .extend-flex-center;
  background: $Vars-background-light-gray;
  position: relative;
  .card {
    @extend .extend-card-login;
    .info {
      width: 500px;
      @extend .extend-flex-column-normal;
      .title {
        font-size: $Vars-font-mainTitle-size;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .line {
        margin-top: 30px;
        @extend .extend-flex-start;
        .label {
          font-size: $Vars-font-content-size;
          text-align: left;
          width: 80px;
        }
        .input {
          width: 300px;
          margin-right: 20px;
        }
        .forget {
          font-size: $Vars-font-secondary-size;
          @extend .extend-clickElement;
          &:hover {
            color: $Vars-normal-color;
          }
        }
        .img {
          width: 100px;
          height: 40px;
          @extend .extend-clickElement;
        }
      }
    }
    .btnGroup {
      margin-top: 30px;
      @include grid-column(auto, 200px, 50px);
      justify-content: center;
      .el-button {
        width: 200px;
        margin: 0 !important;
      }
    }
  }
  .beian {
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 100%;
    text-align: center;
    font-size: $Vars-font-secondary-size;
    text-decoration: none;
    color: black;
  }
}
</style>